<script lang="ts">
    import {copyClipboard} from "src/components/cabinet/#common/helpers"
    import emptyList from './empty.svg'
    import icon1 from './icon-1.svg'
    import icon2 from './icon-2.svg'
    import icon3 from './icon-3.svg'
    import {groupTransactionsByDate} from "src/components/cabinet/#common/helpers";
    import {roundNumber} from 'src/components/#common/helpers/helpers'
    import Time from 'svelte-time'

    let transactionsGroups
    export let transactions
    export let loading
    let lastItem

    $:if (!transactions) {
        transactionsGroups = null
    } else {
        transactionsGroups = groupTransactionsByDate(transactions)
        lastItem = transactions[transactions.length - 1]
    }

    async function copy(value) {
        copyClipboard(value)
    }

    let options = { year: 'numeric', month: 'long', day: 'numeric' }

    function isObject(obj) {
        return typeof obj === 'object'
    }

    function getCurrency(currency) {
        if (['LIS', 'PLIS', 'WLIS', 'PWLIS', 'BLIS'].includes(currency)) {
            return 'DRAG'
        } else if (['DOGE', 'PDOGE', 'WDOGE', 'PWDOGE', 'BDOGE'].includes(currency)) {
            return 'DOGE'
        } else if (['PEPE', 'PPEPE', 'WPEPE', 'PWPEPE', 'BPEPE'].includes(currency)) {
            return 'PEPE'
        } else if (currency == 'TLIS') {
            return 'Test LIS'
        }
        return currency
    }

    let walletTransactions = ['transactions', 'transaction', 'converter', 'googlePlay', 'withdraw', 'staking'];
    let gameTransactions = ['cats', 'dragons', 'foxes', 'shop--cats', 'listeria', 'offer', 'save-streak', 'elon', 'dogecoin', 'pepe'];
</script>

{#if !transactionsGroups || transactionsGroups.length === 0}
    <div class="content-empty">
        {#if !transactionsGroups}
            <div class="title">Loading...</div>
            <div class="description">Your transactions will be displayed here</div>
        {:else}
            <div class="title">No activities yet</div>
            <div class="description">Start your activity by following a few steps</div>
        {/if}
        <img src="{emptyList}" alt="">
    </div>
{:else}
    <div class="panel-gray mb-4">
        <div class="transaction-list">
            {#each transactionsGroups as transactions}
                <div class="date">{transactions[0].createdAt.toLocaleDateString("en-EN",options)}</div>
                {#each transactions as {createdAt, credit, debit, currency, reason, creator, extraDetail}, i}
                    <div class="transaction" class:last={i === transactions.length-1}>
                        <div class="icon">
                            {#if walletTransactions.includes(creator)}
                                <img src="{icon1}" alt="">
                            {:else if gameTransactions.includes(creator)}
                                <img src="{icon2}" alt="">
                            {:else}
                                <img src="{icon3}" alt="">
                            {/if}
                        </div>
                        <div class="info">
                            <div class="description">
                                {#if +debit !== 0}
                                    <span class="green">+{roundNumber(+debit)} {getCurrency(currency)}
                                    </span> <span class="divider">-</span>
                                {:else if +credit !== 0}
                                    <span class="red">-{roundNumber(+credit)} {getCurrency(currency)}
                                    </span> <span class="divider">-</span>
                                {:else}
                                    <span>0</span> <span class="divider">-</span>
                                {/if}
                                {#if isObject(reason)}
                                    <span>{Object.values(JSON.parse(reason))[0]}</span>
                                {:else if reason !== '{}'}
                                    <span>{reason}</span>
                                {/if}
                            </div>
                            <div class="bottom">
                                <div class="time">
                                    <Time live relative timestamp={createdAt}/>
                                </div>
                            </div>
                        </div>
                    </div>
                {/each}
            {/each}
        </div>
    </div>
{/if}

<style>
    .content-empty {
        width: 100%;
        text-align: center;
        padding: 150px 0 50px;
    }

    .content-empty .title {
        color: #9592CD;
        font-size: 24px;
        font-weight: 500;
    }

    .content-empty .description {
        color: #9592CD;
        font-size: 18px;
        font-weight: 300;
        margin: 20px 0 40px;
    }

    .content-empty img {
        max-width: 100%;
    }

    .panel-gray {
        border-radius: 20px;
        border: 2px solid #353064;
        background: #1a183a;
        padding: 10px 30px;
    }

    .green {
        color: #27AE60;
    }

    .red {
        color: #EB5757;
    }

    .date {
        color: #9592CD;
        font-size: 18px;
        font-weight: 700;
        margin: 20px 0;
    }

    .transaction {
        display: flex;
        margin: 25px 0;
        position: relative;
        min-height: 65px;
    }

    .icon {
        width: 40px;
        min-width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid #CAD5E0;
        margin-right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .icon:after {
        content: "";
        width: 1px;
        height: 100%;
        background: #61758A;
        left: 20px;
        top: 45px;
        position: absolute;
    }

    .transaction.last .icon:after {
        display: none;
    }

    .description {
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
    }

    .time {
        font-size: 15px;
        color: #61758A;
        margin-top: 5px;
        font-weight: 600;
        margin-right: 15px;
    }

    .copy img {
        transition: .15s;
    }

    .copy:hover img {
        filter: brightness(1.5);
    }

    .bottom {
        display: flex;
    }

    @media(max-width: 1400px) {
        .content-empty {
            padding: 20px 0 40px;
        }
    }

    @media(max-width: 992px) {
        .date {
            font-size: 15px;
            margin: 15px 0;
        }

        .panel-gray {
            padding: 1px 15px;
        }

        .transaction {
            margin: 15px 0;
        }

        .icon {
            width: 30px;
            min-width: 30px;
            height: 30px;
            margin-right: 10px;
        }

        .icon:after {
            left: 14px;
            top: 40px;
        }
    }

    @media(max-width: 767px) {
        .content-empty .title {
            font-size: 20px;
        }

        .content-empty .description {
            font-size: 16px;
            margin: 10px 0 30px;
            justify-content: center;
        }

        .content-empty img {
            max-width: 160px;
        }

        .panel-gray {
            background: none;
            border: 0;
        }

        .date {
            color: #CAD5E0;
            font-weight: 400;
            font-size: 13px;
        }

        .time {
            font-size: 12px;
            color: #61758A;
            margin-top: 1px;
            font-weight: 400;
        }

        .description {
            font-size: 13px;
            font-weight: 400;
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            width: 100%;
            position: relative;
        }

        .transaction {
           min-height: initial;
        }

        .icon {
            margin-top: 3px;
            background: #61758A;
            border: 0;
            padding: 5px;
        }

        .icon img {
            width: 100%;
        }

        .icon:after {
            display: none;
        }

        .divider {
            display: none;
        }

        .info {
            width: 100%;
        }

        .green, .red {
            white-space: nowrap;
        }

        .description span:first-child {
            margin: 7px 0 -7px 0;
            font-size: 15px;
            font-weight: 600;
        }
    }
</style>
